import React, { useState, useRef } from 'react';

import ENUMS from '../../../enums';

const AdsFilter = props => {
  let [cafeNamePart, setCafeNamePart] = useState();
  let formRefrence = useRef();

  const resetForm = event => {
    Array.from(formRefrence.current).forEach(element => {
      if (element.type === 'radio' || element.type === 'checkbox') {
        element.checked = null;
      } else if (element.name === 'resetButton') {
        element.value = locales('fields.reset');
      } else {
        element.value = null;
      }
    });
    setCafeNamePart('');
    props.applyFilters(event);
  };

  return (
    <article>
      <form
        onReset={event => resetForm(event)}
        onSubmit={event => props.applyFilters(event)}
        ref={formRefrence}
        id="filterForm"
        className="card card my-4"
      >
        <header className="text-center card-header">
          <h5 className="font-italic text-muted">{locales('titles.filter')}</h5>
        </header>
        <main className="card-body">
          <div className="d-flex flex-sm-column col-12 flex-md-row justidy-content-between px-1">
            <div className="d-flex col-md-12 col-sm-12 justify-content-between mx-1">
              <div className="d-flex flex-column col-md-6 col-sm-12 align-items-center">
                <input
                  onChange={event => setCafeNamePart(event.target.value)}
                  value={cafeNamePart || ''}
                  name="cafeNamePart"
                  type="text"
                  className="form-control col-12"
                  placeholder={locales('fields.cafe.name')}
                  maxLength={ENUMS.MAX_LENGTH.cafeName}
                />
                <small style={{ color: '#ccc' }}>{locales('maxLength.30')}</small>
              </div>
            </div>
          </div>

          <div className="col-12 d-flex justify-content-end p-0 my-3">
            <input
              name="resetButton"
              type="reset"
              value={locales('fields.reset')}
              className="btn btn-danger w-5 mx-2"
            />
            <button type="submit" id="apply-filter-btn-reservationDay" className="btn btn-success w-5 mx-2">
              {locales('fields.applyFilters')}
            </button>
          </div>
        </main>
      </form>
    </article>
  );
};

export default AdsFilter;
